import {
  Card as MuiCard,
  CardActionArea as MuiCardActionArea,
  type CardActionAreaProps as MuiCardActionAreaProps,
  CardActions as MuiCardActions,
  type CardActionsProps as MuiCardActionsProps,
  CardContent as MuiCardContent,
  type CardContentProps as MuiCardContentProps,
  CardHeader as MuiCardHeader,
  type CardHeaderProps as MuiCardHeaderProps,
  CardMedia as MuiCardMedia,
  type CardMediaProps as MuiCardMediaProps,
  type CardProps as MuiCardProps
} from "@mui/material";

export type CardProps = MuiCardProps;
export type CardContentProps = MuiCardContentProps;
export type CardHeaderProps = MuiCardHeaderProps;
export type CardActionsProps = MuiCardActionsProps;
export type CardActionAreaProps = MuiCardActionAreaProps;
export type CardMediaProps = MuiCardMediaProps;

export const Card = MuiCard;
export const CardContent = MuiCardContent;
export const CardHeader = MuiCardHeader;
export const CardActions = MuiCardActions;
export const CardActionArea = MuiCardActionArea;
export const CardMedia = MuiCardMedia;
